import apiClient from "QueryClient/axiosClient";
import { partnerTermsMetadata } from "../partnerTermsContent";

export const getPartnerTermsStatus = async (token) => {
  const response = await apiClient.get("/policyAcceptances/status", {
    params: {
      policyKey: partnerTermsMetadata.policyKey,
      policyVersion: partnerTermsMetadata.policyVersion,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};
